import { styled } from "styled-components";
import { useParams } from "react-router-dom";
import { useFetchProjectById } from "../../hooks/useFetchProject";
import ProjectForm from "../ui/Forms/ProjectFormComp";

const AdminPage = styled.div`
  @media (max-width: 576px) {
    display: flex;
    justify-content: center;
    align-items: center;
    //  border: 1px solid red;
  }

  .formAlign {
    // border: 1px solid red;
    margin-top: 2rem;
  }
`;

function AdminProjectDashboard() {
  const { projectId } = useParams<{ projectId: string }>();
  const {
    showLoader: isLoading,
    project: fetchedProject,
    LoaderComponent: ProjectLoader,
  } = useFetchProjectById(projectId || "");

  return (
    <>
      <AdminPage className="App-col">
        <div className="formAlign">
          {!isLoading ? (
            <ProjectForm
              initialData={fetchedProject ?? undefined}
              mode={fetchedProject ? "edit" : "add"}
              id={fetchedProject ? projectId : ""}
            />
          ) : (
            ProjectLoader
          )}
        </div>
      </AdminPage>
    </>
  );
}

export default AdminProjectDashboard;
